import * as apiAction from '../actions';

let initialState = {
    user: {},
    points: {},
    bills: [],
    classPool: {},
    classEntity: {},
    packagePool: {},
    lessonEntity: {},
    studentsEntity: {},
    signupEntity: {}
}

export default function apiReducer( state=initialState, action ) {
    if( action.response && action.response.error ) return state;
    switch( action.type ) {
        case apiAction.GET_USER_INFO:

            let studentsEntity = {};

            const students = action.response.students || [];

            for( var i=0; i< students.length; i++ ) {
                studentsEntity["stu_"+students[i].id] = students[i];
            }
            
            return {
                ...state,
                studentsEntity,
                user: action.response
            };

        case apiAction.GET_POINTS:

            let lastPoints = 0;

            for( let i=0; i<action.response.length; i++) {
                if(action.response[i].status === 'valid')
                lastPoints += action.response[i].last;
            }

            return {
                ...state,
                lastPoints: lastPoints,
                points: action.response
            }

        case apiAction.GET_BILLS:

            let bills = [];

            if( action.response.length > 0 ) {
                bills = action.response.filter((value, index, arr) => {
                    return value.status === 'already_paid' || 'refund';
                })
            }

            return {
                ...state,
                bills
            }


        case apiAction.GET_CLASSLIST:
            let classPool = {
                normal : [], 
                activity : []
            };
            let classEntity = {};
            
            for( var i=0; i<action.response.length; i++ ) {
                classPool[action.response[i].type].push(action.response[i]);
                classEntity["class_"+action.response[i].id] = action.response[i];
            }

            return {
                ...state,
                classPool,
                classEntity
            }

        case apiAction.GET_CLASS_INFO:
            let lessonEntity = {};

            const class_times = action.response;

            const class_id = class_times[0].class_id;
            state.classEntity["class_"+class_id].class_times = class_times;

            for( var c=0; c< class_times.length; c++) {
                
                for( var i=0; i<class_times[c].class_lessons.length; i++ ) {
                    lessonEntity["lesson_"+class_times[c].class_lessons[i].id] = class_times[c].class_lessons[i];
                }
            }
            

            return {
                ...state,
                lessonEntity
            }

        case apiAction.GET_PACKAGE_LIST:
            let packagePool = {};
            
            for( var i=0; i<action.response.length; i++ ) {
                    packagePool["package_"+action.response[i].id] = action.response[i];
                }

            return {
                ...state,
                packagePool
            }
        
        case apiAction.SIGNUP_LESSON:

            let signupEntity = {};

            signupEntity["su_"+action.response.id] = action.response;

            return {
                ...state,
                signupEntity
            }

        case apiAction.LOGIN_BY_CODE: 
        default:
        return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/api.js
 **/